import { getIcon } from "./helper";
import { CustomIconProps } from "./types";

export function CustomIcon({ name, width, height, fill }: CustomIconProps) {
  return <>{getIcon({ name, width, height, fill })}</>;
}
